export default __webpack_public_path__ + "static/media/8d.9f6aa30c.svg";